import request from '@/utils/request'

const http = request()

export const applyTasks = params => http.raw(params.nextStep ? '/project/task/apply/submit' : '/project/task/apply/save', params)

export const getTasks = projectId => http.post('/project/task/list', { projectId })

export const reviewTasks = params => http.post('/project/task/review', params)

export const submitTaskArchive = params => http.post('/project/task/archive/submit', params)

export const reviewTaskArchive = params => http.post('/project/task/archive/submit', params)

export const applyBudgets = params => http.raw(params.nextStep ? '/project/budget/apply/submit' : '/project/budget/apply/save', params)

export const getBudgets = projectId => http.post('/project/budget/list', { projectId })

export const exportBudgets = projectId => http.blob('/project/budget/export', { projectId })

export const getBudgetsWithAmount = projectId => http.post('/project/budget/listWithAmount', { projectId })

export const reviewBudgets = params => http.post('/project/budget/review', params)

export const listReport = params => http.post('/project/report/list', params)

export const delReport = (reportId, projectId) => http.post('/project/report/delete', { reportId, projectId })

export const getReport = reportId => http.post(`/project/report/${reportId}`)

export const saveReport = params => http.raw(params.nextStep ? '/project/report/submit' : '/project/report/save', params)

export const reviewReport = params => http.post('/project/report/review', params)

export const saveChangeinfo = params => http.raw(params.nextStep ? '/project/changeinfo/submit' : '/project/changeinfo/save', params)

export const listChangeinfo = params => http.post('/project/changeinfo/list', params)

export const getChangeinfo = changeId => http.post(`/project/changeinfo/${changeId}`)

export const reviewChangeinfo = params => http.post('/project/changeinfo/review', params)

export const delChangeinfo = (changeId, projectId) => http.post('/project/changeinfo/delete', { changeId, projectId })

export const saveApplyBill = params => http.raw(params.nextStep ? '/project/applyBill/submit' : '/project/applyBill/save', params)

export const listApplyBills = params => http.post('/project/applyBill/list', params)

export const listApplyBillBanks = () => http.post('/project/applyBill/banks')

export const getApplyBill = applyId => http.post(`/project/applyBill/${applyId}`)

export const reviewApplyBill = params => http.post('/project/applyBill/review', params)

export const delApplyBill = (applyId, projectId) => http.post('/project/applyBill/delete', { applyId, projectId })

export const saveProgressBill = params => http.raw(params.nextStep ? '/project/bill/submit' : '/project/bill/save', params)

export const listProgressBills = params => http.post('/project/bill/list', params)

export const getProgressBill = billId => http.post(`/project/bill/${billId}`)

export const delProgressBill = (billId, projectId) => http.post('/project/bill/delete', { billId, projectId })

export const reviewProgressBill = params => http.post('/project/bill/review', params)

export const concludePrj = projectId => http.post('/project/conclude', { projectId })

export const listActivity = params => http.post('/project/activity/list', params)

export const listFinCates = params => http.post('/sys/fincate/list', params)
